<template>
  <fragment>
    <b-button @click="$bvModal.show('add-new-group-modal')"
              :disabled="classroomExchangeExpired"
              btn-text="Add New Student Group"
              outline
              small
              class="size-text-btn"/>
    <modal id="add-new-group-modal">
      <template #body>
        <b-overlay :show="sendingData" rounded="sm">
          <template #overlay>
            <div class="text-center">
              <p id="cancel-label">Please wait...</p>
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <h2 class="modal-title">ADD NEW GROUP</h2>
          <p class="modal-subtitle text-center">
            The system will generate a unique username for each student group when they are added
          </p>
          <b-input type="text" maxlength="25" v-model="form.first_name" :errors="errors.first_name"
                   custom-class="common-input common-input--primary"
                   placeholder="Group Name"/>
        </b-overlay>
      </template>
      <template #footer>
        <b-button @click="addStudent(true)" btn-text="SAVE & ADD ANOTHER" :disabled="sendingData"/>
        <b-button @click="addStudent()" btn-text="Save" :disabled="sendingData"/>
      </template>
    </modal>
  </fragment>
</template>

<script>
import {ClassroomService} from "@/core/Services";
import {Modal} from "@/core/components/Modal";
import BInput from "@/core/components/FormInput/Input";
import {Button} from "@/core/components/Button";
import validateForms from "@/core/Mixins/validate-forms";
import {ExchangesMixins} from "@/modules/MyClassrooms/Mixins"

export default {
  name: "ClassroomDetailGroupAddNew",
  components: {
    Modal,
    BInput,
    'b-button': Button,
  },
  mixins: [validateForms, ExchangesMixins],
  data() {
    return {
      form: {
        first_name: ''
      },
      validations: {
        first_name: {
          validate: 'required|letter',
        }
      },
      sendingData: false
    }
  },
  props: {
    classroom: Object,
  },
  methods: {
    addStudent(addMore) {
      if (!this.sendingData && this.isValidForm()) {
        this.sendingData = true
        ClassroomService.createStudent({classroom_id: this.classroom.id, form: {...this.form}}).then((response) => {
          this.$emit('Student:Created:success', response.data)
          if (!addMore) {
            this.$bvModal.hide('add-new-group-modal')
          }
          this.form = {
            first_name: ''
          }
          this.$emit('on-add-student')
          this.sendingData = false
        })
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
@media (max-width 495px)
  .size-text-btn
    font-size 10px

</style>
